module.exports = {
    "collectionLabel": `Predlogi`
};


//# sourceMappingURL=sl-SI.main.js.map
